import styled from 'styled-components';

export const StyledWithdrawCardSaleModalContent = styled.div``;

export const StyledWithdrawFromSaleText = styled.p`
  margin: 1.5em 0;
`;
